import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConciliarContaRoutingModule } from './conciliar-conta-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConciliarContaRoutingModule
  ]
})
export class ConciliarContaModule { }
